import * as qs from 'qs'
import _ from 'lodash'
import type Passport from '@patsnap-utils/passport/src/passport'
import { CommonApis } from './apis/common.api'
import type { HeaderService } from '@patsnap-utils/biz'
import { type IAddTrialExtendBody } from './apis/common.api.types'
import { isAxiosError } from './exception'
import { Site, SLD } from '@patsnap-utils/biz';
import { addTrialDeferred } from '@eureka/utils/account'
import { InitCookie } from '@patsnap/init-cookie';

const MAX_TRIAL_STORAGE_KEY = 'ADDTRIAL_clickcount'
const MAX_TRIAL_STORAGE_COUNT = 5

class AddTrialService {
    passport: Passport | void = undefined
    private customProductSource?: string

    ENABLE_AUTO_ADD_TRIAL = true;
    async addTrial(headerService: HeaderService, passport: Passport | void) {
        try {
            this.passport = passport
            const grantedProductIds: string[] | undefined = headerService.account?._info.granted_product_ids
            if (grantedProductIds === undefined) {
                throw new Error('Granted_product_ids is undefined!')
            }
            const extendBody = this.getAddTrialExtendBody()
            const empowerType = this.getEmpowerType(extendBody.from || (extendBody as any).start_from);

            const needAddTrialData = await CommonApis.needAddTrial(empowerType, extendBody);
            this.ENABLE_AUTO_ADD_TRIAL = _.get(needAddTrialData, 'data', false);
            const trialCounts = sessionStorage[MAX_TRIAL_STORAGE_KEY] || 0
            if (this.ENABLE_AUTO_ADD_TRIAL) {
                if (trialCounts > MAX_TRIAL_STORAGE_COUNT) {
                    sessionStorage.removeItem(MAX_TRIAL_STORAGE_KEY)
                    window.location.href = new Site({ sld: SLD.EUREKA, pathname: '403/' }).href
                    throw new Error(`Trial counts is over ${MAX_TRIAL_STORAGE_COUNT}!`);
                }
                await CommonApis.addTrial(empowerType, extendBody.from, extendBody)
                localStorage.removeItem('patsnap_header_account_info')
                console.warn('[AddTrial]', '恭喜你获得试用权限啦！')
                if (!this.passport) throw new Error('passport is not setup!')
                this.passport?.removeLocal()
                // /** 用户赋权的次数 */
                if (sessionStorage[MAX_TRIAL_STORAGE_KEY]) {
                    sessionStorage[MAX_TRIAL_STORAGE_KEY] = Number(sessionStorage[MAX_TRIAL_STORAGE_KEY]) + 1
                } else {
                    sessionStorage[MAX_TRIAL_STORAGE_KEY] = 1;
                }
                window.location.reload()
            }
        } catch (error) {
            console.error('[AddTrial]', error)
        } finally {
            this.ENABLE_AUTO_ADD_TRIAL = false
            addTrialDeferred.resolve(true);
        }
    }

    setProductSource(productSource: string) {
        this.customProductSource = productSource;
    }

    isMobileDevice() {
        return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
            navigator.userAgent
        );
    }

    // [‘eureka-seo-patent-detail’] includes from 则return eureka-seo-rd
    getProductSource() {
        const searchParams = new URLSearchParams(window.location.search);
        const from = searchParams.get('from') || searchParams.get('start_from');
        if (from && from.startsWith('eureka-seo-materials-')) {
            return 'eureka-seo-mse';
        }
        if (from && from.startsWith('eureka-seo-')) {
            return 'eureka-seo-rd';
        }

        const currentPath = window.location.pathname;
        if (currentPath.includes('/customize-list')) {
            return 'customize';
        }
        if (currentPath.includes('/agent-list')) {
            return 'agent_list';
        }
        if (from) {
            return from;
        }
        return 'eureka_home';
    }

    getSource() {
        const searchParams = new URLSearchParams(window.location.search);
        const from = searchParams.get('from') || searchParams.get('start_from');
        if (from && from.startsWith('eureka-seo-')) {
            return from
        }
        return InitCookie.getCampaignName();
    }

    getCookieExtendBody() {
        return {
            source: this.getSource(),
            entry_channel: InitCookie.getEntryChannel(),
            product_source: this.customProductSource || this.getProductSource(),
        };
    }

    getAddTrialExtendBody(): IAddTrialExtendBody {
        const hash = window.location.hash;
        const queryString = hash.includes('?') ? '?' + hash.split('?')[1] : window.location.search;

        const query = qs.parse(queryString, {
            ignoreQueryPrefix: true,
        })
        // warning: 直接全部给后端可能会带有多余的参数
        // @ts-ignore
        return {
            ...query,
            ...this.getCookieExtendBody(),
            media_type: this.isMobileDevice() ? 'Mobile' : '',
        }
    }

    getEmpowerType(from?: string) {
        const SEO_SOURCES = [
            'eureka-seo-report-detail',
            'eureka-seo-report-list',
            'eureka-seo-article',
            'eureka-seo-insight',
            'discovery_seo_company'
        ];
        if (from && SEO_SOURCES.includes(from)) return 'RD_SEO';
    }
}

export const addTrialService = new AddTrialService()

export function errorHandleIgnore403(e: Error) {
    return isAxiosError(e) && e.response?.status === 403;
}
